import { render, staticRenderFns } from "./Busanmietung.vue?vue&type=template&id=52f0e060&scoped=true&"
import script from "./Busanmietung.vue?vue&type=script&lang=js&"
export * from "./Busanmietung.vue?vue&type=script&lang=js&"
import style0 from "./Busanmietung.vue?vue&type=style&index=0&id=52f0e060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f0e060",
  null
  
)

export default component.exports